import { Helmet } from 'react-helmet'
import TestimonialBoxSwitcher from './TestimonialBoxSwitcher'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Testimonial Box Switcher</title>
    </Helmet>
    <TestimonialBoxSwitcher />
  </>
)
export default Wrapper
